<ng-container *hasPermission="['ACCOUNTS_READ','ACCOUNTS_ALL', 'SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Account - <b>{{detail_title}}</b></h2>
        </div>
        <form name="accountForm" #f="ngForm" (ngSubmit)="onSubmit(f)">

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="organizationId" class="form-label">Ente</label>
                    <select class="form-select" id="organizationId" name="organizationId"
                        [(ngModel)]="account.organizationId" required>
                        <option [ngValue]="undefined"></option>
                        <option *ngFor="let organization of organizations" [ngValue]="organization.id">
                            {{organization.name}}
                        </option>
                    </select>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="role" class="form-label">Ruolo</label>
                    <select class="form-select" id="role" name="role" [(ngModel)]="account.role" required>
                        <option [ngValue]="undefined"></option>
                        <option *ngFor="let role of roles" [ngValue]="role.id">{{role.description}}</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="username" class="form-label">Username</label>
                    <input type="text" class="form-control" id="username" name="username" ngModel
                        [(ngModel)]="account.username" required />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="email" class="form-label">Email</label>
                    <input type="email" class="form-control" id="email" name="email" ngModel
                        [(ngModel)]="account.email" required email />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="firstName" class="form-label">Nome</label>
                    <input type="text" class="form-control" id="firstName" name="firstName" ngModel
                        [(ngModel)]="account.firstName" required />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="lastName" class="form-label">Cognome</label>
                    <input type="text" class="form-control" id="lastName" name="lastName" ngModel
                        [(ngModel)]="account.lastName" required />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="fiscalCode" class="form-label">Codice fiscale</label>
                    <input type="text" class="form-control" id="fiscalCode" name="fiscalCode" ngModel
                        [(ngModel)]="account.fiscalCode" required />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="code" class="form-label">Codice</label>
                    <input type="text" class="form-control" id="code" name="code" ngModel
                        [(ngModel)]="account.code" required />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="qualificationName" class="form-label">Qualifica</label>
                    <input type="text" class="form-control" id="qualificationName" name="qualificationName" ngModel
                        [(ngModel)]="account.qualificationName" required />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="qualificationDescription" class="form-label">Descrizione qualifica</label>
                    <input type="text" class="form-control" id="qualificationDescription" name="qualificationDescription"
                        ngModel [(ngModel)]="account.qualificationDescription" required />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="agentKey" class="form-label">Chiave agente</label>
                    <input type="text" class="form-control" id="agentKey" name="agentKey" ngModel
                        [(ngModel)]="account.agentKey" />
                </div>
            </div>

            <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>
                <ng-template [hasPermission]="['ACCOUNTS_CREATE', 'ACCOUNTS_UPDATE', 'ACCOUNTS_ALL','SAFESTREET_ADMIN']">
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                </ng-template>
            </div>
        </form>
    </div>
</ng-container>
